import { Link, NavLink } from 'react-router'
import { Stack, TableCell, TableRow, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { formatBigMoney, formatDateYYYYMMDD } from '../../../../packages/utils/numberFormatters'
import React from 'react'
import { getSubPriceLabel } from '../../../../utils/issues/getSubPriceLabel'
import IssueTypeLabels from '../../../../components/entities/IssueTypeLabels'
import { IssueEntity } from 'types/IssueEntity'
import { TFunction } from 'i18next'

type IssueObject = {
    type: 'issue'
    subStartDate: string
    subEndDate: string
    item: IssueEntity
}

const issueTypeLabel = (type: string, t: TFunction) => {
    if (type === 'Guarantor fee issue') return t('pages.companies.guarantorIssue')
    if (type === 'ABB Directed issue') return t('pages.companies.abbDirectedIssue')
    return t(`entities.issueType.values.${type}`)
}

export function IssueTableRow({
    obj,
    locale,
    isLargeScreen,
    multipleInstrumentsExists = false,
}: {
    obj: IssueObject
    locale: string
    isLargeScreen: boolean
    multipleInstrumentsExists: boolean
}) {
    const { t } = useTranslation()
    const issue = obj.item

    const subPriceLabel = getSubPriceLabel({ issue, locale })

    return (
        <TableRow>
            {multipleInstrumentsExists && isLargeScreen ? <TableCell>{issue.instrumentSymbol}</TableCell> : null}
            <TableCell>
                <Stack
                    direction={{ sx: 'column', sm: 'row' }}
                    spacing={2}
                    sx={{
                        alignItems: { xs: 'start', sm: 'center' },
                    }}
                >
                    <IssueTypeLabels
                        hasWarrants={!!issue.hasWarrants}
                        isRto={!!issue.rto}
                        isSpac={!!issue.spac}
                        issueType={issue.type}
                        unitExtraContent={issue.unitExtraContent}
                        sharesInUnit={issue.sharesInUnit}
                    />
                    {issue.type === 'Guarantor fee issue' ? issueTypeLabel(issue.type, t) : null}
                    {issue.type !== 'Guarantor fee issue' ? (
                        <Link component={NavLink} to={`/issues/${issue.id}`}>
                            {issueTypeLabel(issue.type, t)}
                            {issue.type === 'Non-cash issue' && ` (${issue.noncashConsideration})`}
                        </Link>
                    ) : null}
                </Stack>
            </TableCell>
            <TableCell>
                {issue.type === 'Rights issue'
                    ? `${formatDateYYYYMMDD(issue.subStartDate, { locale })} - ${formatDateYYYYMMDD(issue.subEndDate, { locale })}`
                    : formatDateYYYYMMDD(obj.subStartDate, { locale })}
            </TableCell>
            <TableCell>
                <span style={{ whiteSpace: 'pre' }}>{subPriceLabel}</span>
            </TableCell>
            {isLargeScreen ? (
                <TableCell>
                    <Typography>
                        {issue.totalUnitSize !== null
                            ? formatBigMoney(issue.totalUnitSize, { locale, currencySymbol: issue?.currency })
                            : null}
                    </Typography>
                </TableCell>
            ) : null}
        </TableRow>
    )
}
